const projectsData = [
  {
    id: 1,
    image:
      "https://user-images.githubusercontent.com/121726509/264340013-17ebadab-91ad-4c54-ab6e-608ab5537d68.png",
    title: "MERN E-Commerce Project",
  },
  {
    id: 2,
    image:
      "https://github.com/Vikash-Khadoliya/Portfolio-Project/blob/main/vp.png?raw=true",
    title: "Portfolio Project",
    code: "https://github.com/Vikash-Khadoliya/Portfolio-Project.git",
  },
  
];

export default projectsData;
